import { createAction } from '@reduxjs/toolkit'

export const subscribeEmail = createAction<string>('SUBSCRIBE_EMAIL')

export const hideSubscriptionSuccessMessage = createAction(
  'HIDE_SUBSCRIPTION_SUCCESS_MESSAGE'
)
export const subscribeEmailSuccess = createAction('SUBSCRIBE_EMAIL_SUCCESS')
export const subscribeEmailFailure = createAction('SUBSCRIBE_EMAIL_FAILURE')
